(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lucidius-account-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const button = event.target.closest('[data-account-password]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.hide : button.dataset.show;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lucidius-unit-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucidius-unit-price')) {
    customElements.define('lucidius-unit-price', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.update = cents => {
          if (!Number.isSafeInteger(cents) || cents < 0) return;
          const each = Math.round(cents / Number(this.dataset.count));
          const value = new Intl.NumberFormat(this.dataset.locale, { minimumFractionDigits:2, maximumFractionDigits:2 }).format(each / 100);
          const money = this.dataset.money.replace(/[\d.,\s\u00a0\u202f]+(?=[^\d.,]*$)/, value + ' ').trim();
          const copy = (cents % Number(this.dataset.count) ? '≈ ' : '') + this.dataset.copy.replace('__price__', money);
          const label = this.querySelector('.lucidius-each-price');
          if (label.textContent !== copy) label.textContent = copy;
        };
        this.onVolume = () => this.update(Number(this.productInfo.dataset.volumeDisplayPriceCents || this.dataset.price));
        this.productInfo.addEventListener('lucidius:volume-price', this.onVolume);
        this.unsubscribe = typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data?.sectionId === this.dataset.section) this.update(event.data.variant.price);
        }) : null;
        this.onVolume();
      }
      disconnectedCallback() {
        this.productInfo?.removeEventListener('lucidius:volume-price', this.onVolume);
        this.unsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
